import React, { useEffect, useState } from 'react';
import Icon from '../AppIcon';
import { cn } from '../../utils/cn';

const AchievementNotification = ({ achievement, memberName, memberColor, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (achievement) {
      setIsVisible(true);
      
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(() => onClose?.(), 300);
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [achievement, onClose]);

  if (!achievement) return null;

  return (
    <div 
      className={cn(
        'fixed top-4 right-4 z-50 max-w-sm w-full transform transition-all duration-300',
        isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
      )}
    >
      <div 
        className="bg-card rounded-xl shadow-2xl border-2 p-4 flex items-start gap-3"
        style={{ borderColor: achievement?.color }}
      >
        <div 
          className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center"
          style={{ backgroundColor: `${achievement?.color}20` }}
        >
          <Icon name={achievement?.icon} size={24} color={achievement?.color} />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="text-sm font-semibold text-foreground">Achievement Unlocked!</span>
            <div 
              className="w-5 h-5 rounded-full flex items-center justify-center text-white text-xs font-semibold"
              style={{ backgroundColor: memberColor }}
            >
              {memberName?.charAt(0)}
            </div>
          </div>
          <p className="text-sm font-medium text-foreground mb-0.5">
            {achievement?.title}
          </p>
          <p className="text-xs text-muted-foreground">
            {memberName} • {achievement?.description}
          </p>
        </div>

        <button
          onClick={() => {
            setIsVisible(false);
            setTimeout(() => onClose?.(), 300);
          }}
          className="flex-shrink-0 p-1 hover:bg-muted rounded transition-smooth"
          aria-label="Close notification"
        >
          <Icon name="x" size={16} className="text-muted-foreground" />
        </button>
      </div>
    </div>
  );
};

export default AchievementNotification;
